module.exports = __webpack_public_path__ + "media/images/ceremony/ceremony-wedding-lineup-fukuoka-2-79a85ce51aed4e93224fed159897c107.png";